import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Decorative brand background for the Cateno landing shell: concentric circles
 * stroked in the client's primary color over the shell's `--landing-bg`.
 * The stroke color comes from the inherited `--primary` CSS var (set at runtime
 * by ThemeService), so no inputs are needed. Replaces the old decorative-vector rules.
 */
/** Radial step (px) between rings. */
const RING_STEP_PX = 120;
/** Largest ring radius (px) — extended well past the viewport so the pattern
 *  keeps filling the frame, including when the page is zoomed out. */
const RING_MAX_PX = 2400;

@Component({
  selector: 'app-landing-background',
  templateUrl: './landing-background.component.html',
  styleUrls: ['./landing-background.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingBackgroundComponent {
  /**
   * Circle radii (px): evenly spaced at a constant step and extended far past
   * the frame so the rings fill the screen and survive zoom-out. Centered on
   * the card; the host clips whatever overflows.
   */
  readonly radii = Array.from({ length: RING_MAX_PX / RING_STEP_PX }, (_, i) => RING_STEP_PX * (i + 1));
}
